module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Contact us")]), _vm._v(" "), _c('h3', [_vm._v("We'd Love to Hear From You.")])]), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('sk-form', {
    on: {
      "submit": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What can we help you with?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.help_options,
      "label": "name",
      "track-by": "id",
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false
    },
    on: {
      "select": _vm.help_selected,
      "remove": _vm.help_removed
    },
    model: {
      value: (_vm.help),
      callback: function($$v) {
        _vm.help = $$v
      },
      expression: "help"
    }
  })], 1), _vm._v(" "), (_vm.isActive) ? [(_vm.isBrowsing) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What Part of Browsing Tickets Can We Help You With?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.browsing_options,
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false,
      "validation-value": _vm.browsing_selected,
      "required": ""
    },
    model: {
      value: (_vm.browsing_selected),
      callback: function($$v) {
        _vm.browsing_selected = $$v
      },
      expression: "browsing_selected"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.isTicketing) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Which Movie Card do you need help with?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketing_options,
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false,
      "validation-value": _vm.ticketing_selected,
      "required": ""
    },
    model: {
      value: (_vm.ticketing_selected),
      callback: function($$v) {
        _vm.ticketing_selected = $$v
      },
      expression: "ticketing_selected"
    }
  })], 1), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Name of Movie(s)",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_movie_name),
      callback: function($$v) {
        _vm.ticketing_movie_name = $$v
      },
      expression: "ticketing_movie_name"
    }
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of booking")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "max": "31",
      "min": "1",
      "type": "number",
      "placeholder": "Day",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_date_day),
      callback: function($$v) {
        _vm.ticketing_date_day = $$v
      },
      expression: "ticketing_date_day"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketing_date_month,
      "searchable": false,
      "placeholder": "Month"
    },
    model: {
      value: (_vm.ticketing_date_month_selected),
      callback: function($$v) {
        _vm.ticketing_date_month_selected = $$v
      },
      expression: "ticketing_date_month_selected"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "min": "2015",
      "type": "number",
      "placeholder": "Year",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_date_year),
      callback: function($$v) {
        _vm.ticketing_date_year = $$v
      },
      expression: "ticketing_date_year"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Time of movie")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.ticketing_movie_time,
      "searchable": false,
      "placeholder": "Choose time of movie",
      "validation-value": _vm.ticketing_date_month_selected,
      "required": ""
    },
    model: {
      value: (_vm.ticketing_date_month_selected),
      callback: function($$v) {
        _vm.ticketing_date_month_selected = $$v
      },
      expression: "ticketing_date_month_selected"
    }
  })], 1)]), _vm._v(" "), _c('sk-spacer')], 1), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Cinema",
      "placeholder": "e.g Sandton",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_cinema),
      callback: function($$v) {
        _vm.ticketing_cinema = $$v
      },
      expression: "ticketing_cinema"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Type of Ticket",
      "placeholder": "e.g SK Club Card Ticket",
      "required": ""
    },
    model: {
      value: (_vm.ticketing_ticket_type),
      callback: function($$v) {
        _vm.ticketing_ticket_type = $$v
      },
      expression: "ticketing_ticket_type"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isClubLoyalty) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Which Movie Card do you Need Help With?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.club_loyalty_options,
      "searchable": false,
      "placeholder": "Please choose an option",
      "multiple": false,
      "validation-value": _vm.club_loyalty_selected,
      "required": ""
    },
    model: {
      value: (_vm.club_loyalty_selected),
      callback: function($$v) {
        _vm.club_loyalty_selected = $$v
      },
      expression: "club_loyalty_selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What Can We Help You With?")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.club_loyalty_struggles,
      "searchable": false,
      "placeholder": "Please choose an club or movie card",
      "multiple": false,
      "validation-value": _vm.club_loyalty_struggles_selected,
      "required": ""
    },
    model: {
      value: (_vm.club_loyalty_struggles_selected),
      callback: function($$v) {
        _vm.club_loyalty_struggles_selected = $$v
      },
      expression: "club_loyalty_struggles_selected"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.isSubsClub) ? [(_vm.isGuest) ? [_c('sk-panel', [_c('h2', [_vm._v("SK FAN CLUB")]), _vm._v(" "), _c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Watch more movies, for less!")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAs a SK Subscription Club member, you can get a subscription for a Limited or Unlimited\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tamount of movies per month at a set cost, which you pay per month. This means\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tyou can now watch more movies at a lower price, whilst also enjoying the benefits\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tof the SK Club\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/subscription-club",
      "contextValue": "Contact Us Type",
      "dataValue": "VIEW PRICING OPTIONS"
    }
  }, [_vm._v("VIEW PRICING OPTIONS")])], 1)])])], 1)], 1)] : [(_vm.user.PreferenceList.includes(5) || _vm.user.PreferenceList.includes(6)) ? [_c('sk-input', {
    attrs: {
      "label": "First name",
      "required": ""
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Surname",
      "required": ""
    },
    model: {
      value: (_vm.surname),
      callback: function($$v) {
        _vm.surname = $$v
      },
      expression: "surname"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your mobile number",
      "type": "tel",
      "name": "mobile",
      "required": "",
      "placeholder": "eg. +27827804800",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your email",
      "type": "email",
      "required": "",
      "placeholder": "e.g. xxx@gmail.com",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Card number",
      "required": ""
    },
    model: {
      value: (_vm.tmp_card_number),
      callback: function($$v) {
        _vm.tmp_card_number = $$v
      },
      expression: "tmp_card_number"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.card_number),
      callback: function($$v) {
        _vm.card_number = $$v
      },
      expression: "card_number"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.compiled_value),
      callback: function($$v) {
        _vm.compiled_value = $$v
      },
      expression: "compiled_value"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "type": "hidden"
    },
    model: {
      value: (_vm.member_id),
      callback: function($$v) {
        _vm.member_id = $$v
      },
      expression: "member_id"
    }
  })] : [_c('sk-panel', [_c('h2', [_vm._v("SK FAN CLUB")]), _vm._v(" "), _c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Watch more movies, for less!")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAs a SK Subscription Club member, you can get a subscription for a Limited or Unlimited\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tamount of movies per month at a set cost, which you pay per month. This means\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tyou can now watch more movies at a lower price, whilst also enjoying the benefits\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tof the SK Club\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/subscription-club",
      "contextValue": "Contact Us Type",
      "dataValue": "VIEW PRICING OPTIONS"
    }
  }, [_vm._v("VIEW PRICING OPTIONS")])], 1)])])], 1)], 1)]]] : _vm._e(), _vm._v(" "), (_vm.isGuest && !_vm.isSubsClub) ? [_c('sk-input', {
    attrs: {
      "label": "First name",
      "required": ""
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Surname",
      "required": ""
    },
    model: {
      value: (_vm.surname),
      callback: function($$v) {
        _vm.surname = $$v
      },
      expression: "surname"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your email",
      "type": "email",
      "required": "",
      "placeholder": "e.g. xxx@gmail.com",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Your mobile number",
      "type": "tel",
      "name": "mobile",
      "required": "",
      "placeholder": "eg. +27827804800",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isSubsClub) ? [(!_vm.isGuest) ? [(_vm.user.PreferenceList.includes(5) || _vm.user.PreferenceList.includes(6)) ? [_c('sk-textarea', {
    staticClass: "dark-area",
    attrs: {
      "label": "Leave Us a Comment"
    },
    model: {
      value: (_vm.contact_message),
      callback: function($$v) {
        _vm.contact_message = $$v
      },
      expression: "contact_message"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingSubmit
    }
  }, [_vm._v("Send us your feedback")])] : _vm._e()] : _vm._e()] : [_c('sk-textarea', {
    staticClass: "dark-area",
    attrs: {
      "label": "Leave Us a Comment"
    },
    model: {
      value: (_vm.contact_message),
      callback: function($$v) {
        _vm.contact_message = $$v
      },
      expression: "contact_message"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit",
      "loading": _vm.loadingSubmit
    }
  }, [_vm._v("Send us your feedback")])]] : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('address', [_c('h4', [_vm._v("Customer Care")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("South Africa:")]), _vm._v(" 0861 MOVIES (668437)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Namibia:")]), _vm._v(" 0860 0095 05")])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Email")]), _vm._v(" "), _c('p', [_vm._v("info@sterkinekor.com")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("For corporate or block bookings please contact us on:")])]), _vm._v(" "), _c('p', [_vm._v("corporate@sterkinekor.com")])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Whistle-Blowers")]), _vm._v(" "), _c('p', [_vm._v("0800 225 111")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": " https://www.whistleblowing.co.za/make-a-report-steps/",
      "target": "_blank"
    }
  }, [_vm._v("Make a report online")])])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Postal Address")]), _vm._v(" "), _c('p', [_vm._v("PO Box 76461")]), _vm._v(" "), _c('p', [_vm._v("Wendywood")]), _vm._v(" "), _c('p', [_vm._v("2144")])]), _vm._v(" "), _c('address', [_c('h4', [_vm._v("Physical Address")]), _vm._v(" "), _c('p', [_vm._v("Ster-Kinekor Office Park")]), _vm._v(" "), _c('p', [_vm._v("185 Katherine Street")]), _vm._v(" "), _c('p', [_vm._v("Eastgate Ext.4")]), _vm._v(" "), _c('p', [_vm._v("Sandton")])])])], 1)], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.successDialog),
      callback: function($$v) {
        _vm.successDialog = $$v
      },
      expression: "successDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.successDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.successDialog = false
      }
    }
  }), _vm._v(" "), (_vm.isSubsClub) ? [_c('h3', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("You will be contacted shortly.")])] : [_c('h3', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("Thank you for giving us your feedback!")])], _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.successDialog = false
      }
    }
  }, [_vm._v("Close")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29762711","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contact-us/contact-us.vue
// module id = 578
// module chunks = 0